import clx from 'classnames';
import type React from 'react';
import { down } from 'styled-breakpoints';
import styled from 'styled-components';

const FlexSubmissionRowWrapper = styled.div`
  display: flex;
  flex: 1 0 auto;
  min-width: 0;
  ${down('sm')} {
    flex-direction: column;
  }
`;
const FixedCol = styled.div`
  flex: 0 0 auto;
  min-width: 0;
  &.menu-side-left {
    margin-right: 24px;
    order: 1;
  }
  &.menu-side-right {
    margin-left: 24px;
    order: 2;
    ${down('sm')} {
      width: 100%;
      margin-left: 0;
      margin-top: 24px;
    }
  }
  ${down('sm')} {
    &.show-before {
      &.menu-side-left,
      &.menu-side-right {
        order: 0;
      }
    }
  }
  ${down('sm')} {
    width: 100%;
    position: relative;
    flex: 1 1 auto;
    margin-right: 0;
    margin-left: 0;
  }
`;
const FlexCol = styled.div`
  flex: 1 1 auto;
  min-width: 0;
  position: relative;
  &.menu-side-left {
    order: 2;
  }
  &.menu-side-right {
    order: 1;
  }
`;
const StickyMenu = styled.div`
  position: sticky;
  top: calc(var(--header-height, 0px) + var(--content-padding, 24px));
  width: ${props => props.theme.sectionNavigationWidth}px;
  ${down('md')} {
    width: ${props => props.theme.sectionNavigationWidthMd}px;
  }
  ${down('sm')} {
    width: 100%;
  }
`;

export interface FlexSubmissionMobileRules {
  showBefore?: boolean;
}

export interface FlexSubmissionRowProps
  extends React.HTMLAttributes<HTMLDivElement> {
  menu?: React.ReactNode;
  menuSide?: 'left' | 'right';
  mobileRules?: FlexSubmissionMobileRules;
}

/**
 * Righa con una colonna fissa per il menu e una colonna flexibile per il contenuto
 */
export function FlexSubmissionRow(props: FlexSubmissionRowProps) {
  const { menu, children, menuSide = 'left', mobileRules, ...rest } = props;

  return (
    <FlexSubmissionRowWrapper {...rest}>
      {menu && (
        <FixedCol
          className={clx(`menu-side-${menuSide}`, {
            'show-before': mobileRules?.showBefore,
          })}
        >
          <StickyMenu>{menu}</StickyMenu>
        </FixedCol>
      )}
      <FlexCol className={clx(`menu-side-${menuSide}`)}>{children}</FlexCol>
    </FlexSubmissionRowWrapper>
  );
}
